import { GeoJsonProperties } from "geojson";
import React from "react";

interface TemplateExampleProps {
  template: string[];
  properties: GeoJsonProperties;
}

export const TemplateExample: React.FC<TemplateExampleProps> = ({
  template,
  properties,
}) => {
  return (
    <>
      {template.map((prop, propIndex) => {
        const value = properties?.[prop];

        if (value) {
          return (
            <>
              <ruby
                key={propIndex}
                className="text-lg border-gray-400 border-[1px] border-solid px-2"
              >
                {" "}
                {value}
                <rp>(</rp>
                <rt className="font-mono text-xs">{prop}</rt>
                <rp>)</rp>
              </ruby>
              {propIndex !== template.length - 1 && <span> - </span>}
            </>
          );
        }
      })}
    </>
  );
};
